import { takeLatest, put, call, select } from 'redux-saga/effects';
import { SIGN_IN_SAGA } from "../sagaTypes";
import { loadingAction } from '../actions.js';
import { url } from "../../config";
import { toast } from 'react-hot-toast';
import { authAction, setUserAction } from "../actions";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { AUTH_FORM_INITIAL } from "../initialStateConstants";
import { getBookingSagaAction, getSubscriptionsSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/sign_in`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerSignIn(args) {
    const est = yield select(state => state.est);

    yield put(loadingAction(true));
    try {
        let formData = new FormData();
        formData.append('email', args.data?.email);
        formData.append('password', args.data?.password);

        if (est.slug && est.id) {
            formData.append('slug', est.slug);
            formData.append('est', est.id);
        }

        const response = yield call (request, formData);

        if (response.success) {
            // Добавляем hash в локальное хранилище
            setLocalStorage('afw_u', response.user.hash).then();
            // Сохраняем данные пользователя
            yield put(setUserAction(response.user));
            // Сбрасываем данные формы авторизации
            yield put(authAction(AUTH_FORM_INITIAL));
            // Запрашиваем список абонементов пользователя
            yield put(getSubscriptionsSagaAction());

            // Запрашиваем расписание (для пользователя)
            yield put(getBookingSagaAction());

            toast.success(response.message);
        }
        else if (response.error) {
            toast.error(response.message);
        }
    }
    catch(error) {
        console.log(error);
        yield put(loadingAction(false));
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherSignIn() {
    yield takeLatest(SIGN_IN_SAGA, workerSignIn);
}